(function () {
  "use strict";

  var root = document.querySelector("[data-product-selection-desktop]");
  if (!root) {
    return;
  }
  var assetBaseUrl = root.dataset.productSelectionAssetBase.replace(/\/$/, "");
  var header = null;
  var selectorControls = root.querySelector(".selector-controls");
  var platformButtons = Array.from(root.querySelectorAll("[data-platform-filter]"));
  var typeButtons = Array.from(root.querySelectorAll("[data-type-filter]"));
  var productGrid = root.querySelector("[data-product-grid]");
  var productPagination = root.querySelector("[data-product-pagination]");
  var selectorEmpty = root.querySelector("[data-selector-empty]");
  var guideSearch = root.querySelector("[data-guide-search]");
  var guideCards = Array.from(root.querySelectorAll("[data-guide-card]"));
  var guidePagination = root.querySelector("[data-guide-pagination]");
  var guideEmpty = root.querySelector("[data-guide-empty]");
  var comparisonModal = root.querySelector("[data-comparison-modal]");
  var comparisonClose = root.querySelector("[data-comparison-close]");
  var activeComparisonButton = null;
  var activePlatform = "all";
  var activeType = "all";
  var currentProductPage = 0;
  var productsPerPage = 8;
  var currentGuidePage = 0;
  var guidesPerPage = 6;
  var productCatalog = Array.isArray(window.PRODUCT_SELECTION_PRODUCTS) ? window.PRODUCT_SELECTION_PRODUCTS : [];

  function updateHeader() {
    if (!header) {
      return;
    }
    var isFixed = window.scrollY > 48;

  }

  function setActiveButton(buttons, activeButton) {
    buttons.forEach(function (button) {
      var active = button === activeButton;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function updatePlatformTheme() {
    if (selectorControls) {
      selectorControls.dataset.platformTheme = activePlatform;
    }
  }

  function renderPagination(container, pageCount, currentPage, onPageChange) {
    if (!container) {
      return;
    }
    container.replaceChildren();
    container.hidden = pageCount <= 1;
    if (pageCount <= 1) {
      return;
    }

    var previousButton = document.createElement("button");
    previousButton.type = "button";
    previousButton.className = "guide-pagination__arrow guide-pagination__arrow--prev";
    previousButton.setAttribute("aria-label", "Previous page");
    previousButton.disabled = currentPage === 0;
    previousButton.addEventListener("click", function () {
      onPageChange(Math.max(0, currentPage - 1));
    });
    container.appendChild(previousButton);

    var dots = document.createElement("div");
    dots.className = "guide-pagination__dots";
    for (var pageIndex = 0; pageIndex < pageCount; pageIndex += 1) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "guide-pagination__dot";
      button.classList.toggle("is-active", pageIndex === currentPage);
      button.setAttribute("aria-label", "Page " + (pageIndex + 1));
      button.setAttribute("aria-current", pageIndex === currentPage ? "page" : "false");
      (function (targetPage) {
        button.addEventListener("click", function () {
          onPageChange(targetPage);
        });
      })(pageIndex);
      dots.appendChild(button);
    }
    container.appendChild(dots);

    var nextButton = document.createElement("button");
    nextButton.type = "button";
    nextButton.className = "guide-pagination__arrow guide-pagination__arrow--next";
    nextButton.setAttribute("aria-label", "Next page");
    nextButton.disabled = currentPage >= pageCount - 1;
    nextButton.addEventListener("click", function () {
      onPageChange(Math.min(pageCount - 1, currentPage + 1));
    });
    container.appendChild(nextButton);
  }

  function updateTypeButtons() {
    typeButtons.forEach(function (button) {
      var active = button.dataset.typeFilter === activeType;
      button.hidden = false;
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function matchesProductPlatform(platforms, activePlatformKey) {
    var platformList = Array.isArray(platforms) ? platforms : [platforms];
    if (activePlatformKey === "other") {
      return platformList.indexOf("other") !== -1;
    }
    if (activePlatformKey === "all" || platformList.indexOf("all") !== -1) {
      return true;
    }
    return platformList.indexOf(activePlatformKey) !== -1;
  }

  function matchesProductType(type, activeTypeKey) {
    var typeList = Array.isArray(type) ? type : [type];
    if (activeTypeKey === "all") {
      return true;
    }
    return typeList.indexOf(activeTypeKey) !== -1;
  }

  function resolveProductImage(imageUrl) {
    if (!imageUrl) {
      return "";
    }
    if (/^(?:https?:)?\/\//i.test(imageUrl) || imageUrl.charAt(0) === "/") {
      return imageUrl;
    }
    return assetBaseUrl ? assetBaseUrl + "/" + imageUrl.replace(/^\/+/, "") : imageUrl;
  }

  function createProductCard(product) {
    var card = document.createElement("article");
    var media = document.createElement("div");
    var image = document.createElement("img");
    var body = document.createElement("div");
    var title = document.createElement("h3");
    var actions = document.createElement("div");
    var compareButton = document.createElement("button");
    var detailLink = document.createElement("a");

    card.className = "selector-card";
    card.dataset.productCard = "";
    media.className = "selector-card__media";
    image.src = resolveProductImage(product.image);
    image.alt = product.name + " product";
    image.width = 800;
    image.height = 800;
    image.loading = "lazy";
    body.className = "selector-card__body";
    title.textContent = product.name;
    actions.className = "selector-card__actions";
    compareButton.type = "button";
    compareButton.dataset.compareButton = "";
    compareButton.textContent = "Compare";
    compareButton.setAttribute("aria-pressed", "false");
    compareButton.setAttribute("aria-haspopup", "dialog");
    compareButton.setAttribute("aria-controls", "comparison-modal");
    detailLink.href = window.getProductSelectionProductUrl
      ? window.getProductSelectionProductUrl(product)
      : "/products/" + String(product.name || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    detailLink.textContent = "View Details";
    if (detailLink.getAttribute("href") === "#") {
      detailLink.addEventListener("click", function (event) {
        event.preventDefault();
      });
    } else {
      detailLink.target = "_blank";
      detailLink.rel = "noopener noreferrer";
    }

    actions.append(compareButton, detailLink);
    body.append(title, actions);
    media.append(image);
    card.append(media, body);
    return card;
  }

  function renderProducts(products) {
    if (!productGrid) {
      return;
    }
    var fragment = document.createDocumentFragment();
    products.forEach(function (product) {
      fragment.appendChild(createProductCard(product));
    });
    productGrid.replaceChildren(fragment);
  }

  function updateProducts() {
    var filteredProducts = productCatalog.filter(function (product) {
      return matchesProductPlatform(product.platform, activePlatform) && matchesProductType(product.type, activeType);
    });
    var pageCount = Math.ceil(filteredProducts.length / productsPerPage);
    if (currentProductPage >= pageCount) {
      currentProductPage = Math.max(0, pageCount - 1);
    }
    var pageStart = currentProductPage * productsPerPage;
    var pageProducts = filteredProducts.slice(pageStart, pageStart + productsPerPage);

    renderProducts(pageProducts);
    renderPagination(productPagination, pageCount, currentProductPage, function (targetPage) {
      currentProductPage = targetPage;
      updateProducts();
    });
    if (selectorEmpty) {
      selectorEmpty.hidden = filteredProducts.length !== 0;
    }
  }

  platformButtons.forEach(function (button) {
    button.setAttribute("aria-pressed", button.classList.contains("is-active") ? "true" : "false");
    button.addEventListener("click", function () {
      activePlatform = button.dataset.platformFilter;
      currentProductPage = 0;
      setActiveButton(platformButtons, button);
      updatePlatformTheme();
      updateProducts();
    });
  });

  typeButtons.forEach(function (button) {
    button.setAttribute("aria-pressed", button.classList.contains("is-active") ? "true" : "false");
    button.addEventListener("click", function () {
      activeType = button.dataset.typeFilter;
      currentProductPage = 0;
      setActiveButton(typeButtons, button);
      updateProducts();
    });
  });

  function closeComparisonModal() {
    if (!comparisonModal || comparisonModal.hidden) {
      return;
    }
    comparisonModal.hidden = true;
    document.body.classList.remove("is-comparison-open");
    if (activeComparisonButton) {
      activeComparisonButton.classList.remove("is-selected");
      activeComparisonButton.setAttribute("aria-pressed", "false");
      activeComparisonButton.focus();
      activeComparisonButton = null;
    }
  }

  function openComparisonModal(button) {
    if (!comparisonModal) {
      return;
    }
    activeComparisonButton = button;
    button.classList.add("is-selected");
    button.setAttribute("aria-pressed", "true");
    comparisonModal.hidden = false;
    document.body.classList.add("is-comparison-open");
    if (comparisonClose) {
      comparisonClose.focus();
    }
  }

  if (productGrid) {
    productGrid.addEventListener("click", function (event) {
      var button = event.target.closest("[data-compare-button]");
      if (button) {
        openComparisonModal(button);
      }
    });
  }

  if (comparisonClose) {
    comparisonClose.addEventListener("click", closeComparisonModal);
  }

  if (comparisonModal) {
    comparisonModal.addEventListener("click", function (event) {
      if (!event.target.closest(".comparison-modal__dialog")) {
        closeComparisonModal();
      }
    });
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeComparisonModal();
      return;
    }
    if (event.key === "Tab" && comparisonModal && !comparisonModal.hidden && comparisonClose) {
      event.preventDefault();
      comparisonClose.focus();
    }
  });

  function normalizeGuideSearch(value) {
    return value.normalize("NFKC").toLowerCase().replace(/[^a-z0-9\u3400-\u9fff\s]/g, "").replace(/\s+/g, " ").trim();
  }

  function getFilteredGuides() {
    var query = guideSearch ? guideSearch.value : "";
    var keywords = query.split(/[\s,，、;；]+/).map(normalizeGuideSearch).filter(Boolean);
    return guideCards.filter(function (card) {
      var image = card.querySelector("img");
      var title = card.querySelector("h3");
      var searchableText = normalizeGuideSearch([
        card.dataset.search || "",
        card.dataset.tags || "",
        title ? title.textContent : "",
        image ? image.alt : ""
      ].join(" "));
      var searchWords = searchableText.split(" ");
      return keywords.every(function (keyword) {
        return searchableText.indexOf(keyword) !== -1 || searchWords.some(function (word, index) {
          return word + (searchWords[index + 1] || "") === keyword;
        });
      });
    });
  }

  function renderGuidePagination(pageCount) {
    renderPagination(guidePagination, pageCount, currentGuidePage, function (targetPage) {
      currentGuidePage = targetPage;
      updateGuides();
    });
  }

  function updateGuides() {
    var filteredGuides = getFilteredGuides();
    var pageCount = Math.ceil(filteredGuides.length / guidesPerPage);
    if (currentGuidePage >= pageCount) {
      currentGuidePage = Math.max(0, pageCount - 1);
    }
    var pageStart = currentGuidePage * guidesPerPage;
    var pageGuides = filteredGuides.slice(pageStart, pageStart + guidesPerPage);

    guideCards.forEach(function (card) {
      card.hidden = pageGuides.indexOf(card) === -1;
    });
    if (guideEmpty) {
      guideEmpty.hidden = filteredGuides.length !== 0;
    }
    renderGuidePagination(pageCount);
  }

  if (guideSearch) {
    guideSearch.addEventListener("input", function () {
      currentGuidePage = 0;
      updateGuides();
    });
  }

  root.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener("click", function (event) {
      var targetSelector = link.getAttribute("href");
      if (targetSelector === "#") {
        event.preventDefault();
        return;
      }
      var target = root.querySelector(targetSelector);
      if (!target) {
        return;
      }
      event.preventDefault();
      var headerOffset = header ? header.offsetHeight : 0;
      var top = target.getBoundingClientRect().top + window.scrollY - headerOffset;
      window.scrollTo({
        top: top,
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
      });
    });
  });

  updateHeader();
  updatePlatformTheme();
  updateTypeButtons();
  updateProducts();
  updateGuides();
})();
